
function toggleMobileMenu(){var p=document.getElementById('mobilePanel');if(p){p.classList.toggle('active')}}
document.addEventListener('click',function(e){document.querySelectorAll('[data-switcher]').forEach(function(sw){if(!sw.contains(e.target)){sw.classList.remove('open')}})});
document.addEventListener('click',function(e){var trigger=e.target.closest('.switcher-trigger');if(trigger){e.preventDefault();var sw=trigger.closest('[data-switcher]');document.querySelectorAll('[data-switcher]').forEach(function(other){if(other!==sw)other.classList.remove('open')});sw.classList.toggle('open')}});
document.addEventListener('keydown',function(e){if(e.key==='Escape'){document.querySelectorAll('[data-switcher]').forEach(function(sw){sw.classList.remove('open')});var p=document.getElementById('mobilePanel');if(p)p.classList.remove('active')}});
function submitLocaleSelect(select){if(select && select.form){select.form.submit()}}

// Kuvido product page: gallery and variant sync
(function(){
  document.addEventListener('click', function(event) {
    var thumb = event.target.closest('[data-kuvido-product-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-kuvido-gallery]') || thumb.closest('.product-gallery-modern');
    var mainImg = gallery && gallery.querySelector('[data-main-product-image], .product-image-frame img');
    if (mainImg && thumb.dataset.full) {
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = thumb.dataset.full;
    }
    if (gallery) {
      gallery.querySelectorAll('[data-kuvido-product-thumb]').forEach(function(btn){ btn.classList.remove('active'); });
    }
    thumb.classList.add('active');
  });

  function syncVariant(form) {
    if (!form) return;
    var optionSelects = form.querySelectorAll('.variant-option-select');
    var variantSelect = form.querySelector('[data-product-variant-select]');
    if (!variantSelect) return;
    var selectedOptions = Array.prototype.map.call(optionSelects, function(select){ return select.value; });
    var matchedOption = null;
    Array.prototype.forEach.call(variantSelect.options, function(option) {
      var optionValues = (option.getAttribute('data-options') || '').split('||');
      if (optionValues.length === selectedOptions.length && optionValues.every(function(value, index){ return value === selectedOptions[index]; })) {
        matchedOption = option;
      }
    });
    if (!matchedOption) return;
    matchedOption.selected = true;
    var panel = form.closest('.product-buybox-modern');
    var priceBox = panel && panel.querySelector('[data-product-price]');
    var addButton = panel && panel.querySelector('[data-add-button]');
    var price = matchedOption.getAttribute('data-price') || '';
    var compare = matchedOption.getAttribute('data-compare') || '';
    var available = matchedOption.getAttribute('data-available') === 'true' && !matchedOption.disabled;
    if (priceBox) priceBox.innerHTML = '<span>' + price + '</span>' + (compare ? ' <s>' + compare + '</s>' : '');
    if (addButton) {
      addButton.disabled = !available;
      addButton.textContent = available ? 'Add to cart' : 'Sold out';
    }
  }
  document.addEventListener('change', function(event) {
    if (!event.target.matches('.variant-option-select')) return;
    syncVariant(event.target.closest('form'));
  });
})();

// Kuvido v3 — Currency switcher search filter
(function () {
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input.classList.contains('switcher-search-input')) return;
    var query = input.value.toLowerCase().trim();
    var list = input.closest('.switcher-menu').querySelector('.switcher-options-list');
    if (!list) return;
    list.querySelectorAll('.switcher-option').forEach(function (btn) {
      var name = (btn.getAttribute('data-country-name') || '').toLowerCase();
      var currency = (btn.getAttribute('data-currency') || '').toLowerCase();
      var label = btn.textContent.toLowerCase();
      btn.style.display = (name.includes(query) || currency.includes(query) || label.includes(query)) ? '' : 'none';
    });
  });

  // Update aria-expanded on switcher triggers
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.switcher-trigger');
    if (trigger) {
      var sw = trigger.closest('[data-switcher]');
      var isOpen = sw.classList.contains('open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  });

  // Accessible mobile menu toggle
  var origToggle = window.toggleMobileMenu;
  window.toggleMobileMenu = function () {
    var p = document.getElementById('mobilePanel');
    var btn = document.querySelector('.mobile-toggle');
    if (p) {
      var opening = !p.classList.contains('active');
      p.classList.toggle('active');
      p.setAttribute('aria-hidden', opening ? 'false' : 'true');
      if (btn) btn.setAttribute('aria-expanded', opening ? 'true' : 'false');
    }
  };
})();

// Kuvido — update currency trigger label immediately on selection
(function () {
  document.addEventListener('click', function (e) {
    var option = e.target.closest('.switcher-option[data-label]');
    if (!option) return;
    var sw = option.closest('[data-switcher]');
    if (!sw) return;
    var trigger = sw.querySelector('.switcher-trigger span');
    if (trigger && option.dataset.label) {
      trigger.textContent = option.dataset.label;
    }
    // Remove active from all, add to clicked
    sw.querySelectorAll('.switcher-option').forEach(function (btn) {
      btn.classList.remove('active');
      btn.setAttribute('aria-selected', 'false');
    });
    option.classList.add('active');
    option.setAttribute('aria-selected', 'true');
  });
})();
